import ReactGA from 'react-ga4';

const initializeAnalytics = () => {
    ReactGA.initialize('G-JNFDG0PG87');
};

export default initializeAnalytics;
